import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogImage,
  schemaData 
}) => {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://cthomeremodels.com';
  const defaultImage = `https://cthomeremodels.com/og/v2/home.png`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical || siteUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical || siteUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage || defaultImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical || siteUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage || defaultImage} />
      
      {/* Geo Meta Tags */}
      <meta name="geo.region" content="US-CT" />
      <meta name="geo.placename" content="Meriden, Connecticut" />
      <meta name="geo.position" content="41.5382;-72.8071" />
      <meta name="ICBM" content="41.5382, -72.8071" />
      
      {/* Schema.org Structured Data */}
      {schemaData && (
        Array.isArray(schemaData) ? schemaData.map((schema, idx) => (
          <script key={idx} type="application/ld+json">
            {JSON.stringify(schema)}
          </script>
        )) : (
          <script type="application/ld+json">
            {JSON.stringify(schemaData)}
          </script>
        )
      )}
    </Helmet>
  );
};

export default SEO;